(function () {
    'use strict';

    angular
        .module('bcmModule')
        .controller('biaResponsibilityFullController', Controller);

    Controller.$inject = ['$scope', '$state', '$modal', 'biaResponsibilityService', 'notificationService', 'grcCrontabService', 'adminReferenceDataService'];

    function Controller($scope, $state, $modal, biaResponsibilityService, notificationService, grcCrontabService, adminReferenceDataService) {
        if (_.isUndefined($scope.ctrlCtxt)) $scope.ctrlCtxt = {};

        $scope.ctrlCtxt.canEditBIAResponsibility =
            !$scope.boxContext.BIAProfile.IsReadOnly
            && $scope.boxContext.BIAProfile.HasBIAProfile_Edit_Related;

        initExecutionPlan();
        initLocationLookup();
        initSuggestedImpactLevel();

        // Is Save Changes Disabled?
        $scope.isSaveChangesDisabled = function (form) {
            if (_.isUndefined(form)) return;
            return form.$invalid;
        };

        // Go To BIA Responsibility
        $scope.goToBIAResponsibility = function (resp) {
            $state.go('biaProfile.edit.biaBuOwner.biaResponsibility', { BIAResponsibilityID: resp.BIAResponsibilityID });
        };

        // Go to Edit Disruption Impacts
        $scope.goToEditDisruptionImpacts = function () {
            $state.go('biaProfile.edit.biaBuOwner.biaResponsibility.editRatings');
        };

        // Edit Execution Plan
        $scope.editExecutionPlan = function () {

            // Modal to show
            var modalScope = $scope.$new(true);

            modalScope.ctrlCtxt = {};
            modalScope.boxModel = _.cloneDeep($scope.boxModel);
            modalScope.boxContext = _.cloneDeep($scope.boxContext);
            modalScope.isSaveChangesDisabled = $scope.isSaveChangesDisabled;
            modalScope.executionTimeFrame = $scope.executionTimeFrame;

            var showModal = $modal({
                scope: modalScope,
                template: '/app/shared/BCM/BIAResponsibility/biaResponsibility.full_executionPlanEdit.tpl.html',
                placement: 'center',
                backdrop: 'static'
            });

            // On BoxModel Save Changes
            modalScope.onBoxModelSaveChanges = function (form, message) {
                return $scope
                    .updateBIAResponsibility(modalScope.boxModel)
                    .then(function () {
                        modalScope.close();
                        initExecutionPlan();

                        message = message || 'BIA Responsibility updated successfully';
                        notificationService.notify(message);
                    });
            };

            // Close Modal
            modalScope.close = function () {
                showModal.$promise.then(showModal.hide);
            };
        };

        // Update BIA Responsiblity
        $scope.updateBIAResponsibility = function (respToUpd) {

            if (_.isUndefined(respToUpd)) respToUpd = $scope.boxModel;

            return biaResponsibilityService
                .updateBIAResponsibility($scope.boxContext.BIAProfile.BIAProfileID,
                    respToUpd.BIAResponsibilityID,
                    respToUpd)
                .then(function (updatedBIAResp) {
                    var biaRespIdx = _.findIndex($scope.boxContext.BIAResponsibilities, {
                        BIAResponsibilityID: updatedBIAResp.BIAResponsibilityID
                    });

                    if (biaRespIdx !== -1) $scope.boxContext.BIAResponsibilities[biaRespIdx] = updatedBIAResp;
                    $scope.boxModel = updatedBIAResp;

                    // Update model on other views
                    $scope.onResponsibilityUpdated({
                        biaResponsibility: updatedBIAResp
                    });

                    return updatedBIAResp;
                });
        };

        // Delete BIA Responsibility
        $scope.deleteBIAResponsibility = function () {
            biaResponsibilityService
                .deleteBIAResponsibility($scope.boxContext.BIAProfile.BIAProfileID,
                                         $scope.boxModel.BIAResponsibilityID)
                .then(function () {
                    _.remove($scope.boxContext.BIAResponsibilities, {
                        BIAResponsibilityID: $scope.boxModel.BIAResponsibilityID
                    });
                    $state.go('^', {}, { reload: true });
                });
        };

        // Edit Key Person List
        $scope.editKeyPersonList = function () {

            // Modal to show
            var modal;
            var modalScope = $scope.$new(true);

            modalScope.boxModel = $scope.boxModel;
            modalScope.boxContext = $scope.boxContext;
            modalScope.onClose = function () {
                modal.$promise.then(modal.hide);
            };
            modalScope.onKeyPersonAdded = function (keyPerson) {
                $scope.boxContext.BIAKeyPersons.push(keyPerson);
            };

            modal = $modal({
                scope: modalScope,
                template: '/app/shared/BCM/BIAResponsibility/biaResponsibility.keyStaff.modal.tpl.html',
                placement: 'center',
                backdrop: 'static'
            });

            modalScope.$on('modal.hide', function () {
                modalScope.$destroy();
                $state.reload();
            });

        };

        // Edit Key Person
        $scope.editKeyPerson = function (keyPerson) {

            // Modal to show
            var modal;
            var modalScope = $scope.$new(true);

            modalScope.boxModel = $scope.boxModel;
            modalScope.boxContext = $scope.boxContext;
            modalScope.keyPerson = _.cloneDeep(keyPerson);

            modalScope.close = function () {
                modal.$promise.then(modal.hide);
            };
            modal = $modal({
                scope: modalScope,
                template: '/app/shared/BCM/BIAResponsibility/biaResponsibility.keyStaff.edit.modal.tpl.html',
                placement: 'center',
                backdrop: 'static'
            });

            modalScope.$on('modal.hide', function () {
                modalScope.$destroy();
                $state.reload();
            });

        };

        // Edit Key Systems
        $scope.editKeySystems = function () {
            if ($scope.ctrlCtxt.isGettingAvailablesystems) return;

            $scope.ctrlCtxt.isGettingAvailablesystems = true;

            // Modal to show
            var modal;
            var modalScope = $scope.$new(true);

            modalScope.close = function () {
                modal.$promise.then(modal.hide);
            };

            modalScope.$on('modal.hide', function () {
                modalScope.$destroy();
                $state.reload();
            });

            modal = $modal({
                scope: modalScope,
                template: '/app/shared/BCM/BIAResponsibility/biaResponsibility.KeySystems.modal.tpl.html',
                placement: 'center',
                show: false
            });

            biaResponsibilityService
                .getBIAResponsibilityAllSystemsContainer(
                    $scope.boxContext.BIAProfile.BIAProfileID,
                    $scope.boxModel.BIAResponsibilityID)
                .then(function (responsibilitySystemsContainer) {
                    modalScope.biaResponsibility = responsibilitySystemsContainer.BiaResponsibility;
                    modalScope.availableIamSystemList = responsibilitySystemsContainer.AvailableIAMSystemListByType;
                    modalScope.selectedIamSystemList = responsibilitySystemsContainer.SelectedIAMSystemListByType;

                    modal.show();
                })
                .finally(function () {
                    $scope.ctrlCtxt.isGettingAvailablesystems = false;
                });
        };

        // --- Recovery Metrics helpers ---

        // Format minutes to display string (e.g. 130 → "2h 10m")
        $scope.formatMinutes = function (totalMinutes) {
            if (totalMinutes == null) return '';
            var h = Math.floor(totalMinutes / 60);
            var m = totalMinutes % 60;
            if (h > 0 && m > 0) return h + 'h ' + m + 'm';
            if (h > 0) return h + 'h';
            return m + 'm';
        };

        // Has any recovery metrics data
        $scope.hasRecoveryMetrics = function () {
            return $scope.boxModel.MtpdExpertValue != null
                || $scope.boxModel.MtpdCalculatedValue != null
                || $scope.boxModel.Mbco;
        };

        // Get minimum of both MTPD values
        $scope.getMinMtpd = function () {
            var expert = $scope.boxModel.MtpdExpertValue;
            var calc = $scope.boxModel.MtpdCalculatedValue;
            if (expert != null && calc != null) return Math.min(expert, calc);
            if (expert != null) return expert;
            if (calc != null) return calc;
            return null;
        };

        // Edit Recovery Metrics
        $scope.editRecoveryMetrics = function () {

            var modalScope = $scope.$new(true);

            modalScope.ctrlCtxt = {};
            modalScope.boxModel = _.cloneDeep($scope.boxModel);
            modalScope.boxContext = { BIAProfile: $scope.boxContext.BIAProfile };

            var showModal = $modal({
                scope: modalScope,
                template: '/app/shared/BCM/BIAResponsibility/biaResponsibility.recoveryMetrics.edit.tpl.html',
                placement: 'center',
                backdrop: 'static'
            });

            modalScope.onBoxModelSaveChanges = function () {
                return $scope
                    .updateBIAResponsibility(modalScope.boxModel)
                    .then(function () {
                        modalScope.close();
                        notificationService.notify('Recovery Metrics Saved Successfully');
                    });
            };

            modalScope.close = function () {
                showModal.$promise.then(showModal.hide);
            };
        };

        // --- Resource Requirements helpers ---

        // Has any resource requirements data
        $scope.hasResourceRequirements = function () {
            return $scope.boxModel.MinStaffNormal != null
                || $scope.boxModel.MinStaffDegrated != null
                || $scope.boxModel.PrimaryLocationID != null
                || $scope.boxModel.FallbackLocationID != null
                || $scope.boxModel.AdditionalComment;
        };

        // Edit Resource Requirements
        $scope.editResourceRequirements = function () {

            var modalScope = $scope.$new(true);

            modalScope.ctrlCtxt = {};
            modalScope.boxModel = _.cloneDeep($scope.boxModel);
            modalScope.boxContext = _.cloneDeep($scope.boxContext);

            var showModal = $modal({
                scope: modalScope,
                template: '/app/shared/BCM/BIAResponsibility/biaResponsibility.resourceRequirements.edit.tpl.html',
                placement: 'center',
                backdrop: 'static'
            });

            modalScope.onBoxModelSaveChanges = function () {
                return $scope
                    .updateBIAResponsibility(modalScope.boxModel)
                    .then(function () {
                        modalScope.close();
                        notificationService.notify('Resource Requirements Saved Successfully');
                    });
            };

            modalScope.close = function () {
                showModal.$promise.then(showModal.hide);
            };
        };

        // --- Dependencies helpers ---

        // Parse Dependencies JSON — never mutates boxModel.Dependencies
        // Cached to avoid returning new array references on each digest cycle
        var _cachedDepsString = null;
        var _cachedDeps = [];

        function parseDependencies() {
            var raw = $scope.boxModel.Dependencies;
            if (!raw) return [];
            if (_.isArray(raw)) return raw;
            try { return JSON.parse(raw); }
            catch (e) { return []; }
        }

        $scope.getDependencies = function () {
            var raw = $scope.boxModel.Dependencies;
            if (!raw) return [];
            if (raw === _cachedDepsString) return _cachedDeps;
            _cachedDeps = parseDependencies();
            _cachedDepsString = raw;
            return _cachedDeps;
        };

        // Add Dependency
        $scope.addDependency = function () {
            openDependencyModal({ typeId: null, name: '', notes: null, typeName: null }, false);
        };

        // Edit Dependency
        $scope.editDependency = function (index) {
            var deps = parseDependencies();
            openDependencyModal(_.cloneDeep(deps[index]), true, index);
        };

        // Remove Dependency
        $scope.removeDependency = function (index) {
            var deps = parseDependencies();
            deps.splice(index, 1);
            $scope.boxModel.Dependencies = JSON.stringify(deps);
            $scope.updateBIAResponsibility();
        };

        function openDependencyModal(dependency, isEdit, editIndex) {
            var modalScope = $scope.$new(true);

            modalScope.ctrlCtxt = { isEdit: isEdit };
            modalScope.dependency = dependency;
            modalScope.boxContext = $scope.boxContext;

            var showModal = $modal({
                scope: modalScope,
                template: '/app/shared/BCM/BIAResponsibility/biaResponsibility.dependency.edit.tpl.html',
                placement: 'center',
                backdrop: 'static'
            });

            modalScope.onDependencySave = function (dep) {
                var deps = parseDependencies();

                if (isEdit) {
                    deps[editIndex] = dep;
                } else {
                    deps.push(dep);
                }

                $scope.boxModel.Dependencies = JSON.stringify(deps);
                $scope.updateBIAResponsibility()
                    .then(function () {
                        modalScope.close();
                        notificationService.notify(isEdit ? 'Dependency Updated' : 'Dependency Added');
                    });
            };

            modalScope.close = function () {
                showModal.$promise.then(showModal.hide);
            };
        }

        // Go to Edit BIA Responsibility
        $scope.goToEditBIAResponsibility = function () {
            $state.go('biaProfile.edit.biaBuOwner.biaResponsibility.editBIAResponsibility');
        };

        $scope.getExecutionTimeFrameDays = function () {
            return _.join($scope.executionTimeFrame.weekDaysEN, ', ');
        };

        function initExecutionPlan() {
            /*
                Impact Details Time frame are saved in a custom format based on Cron jobs.
                See grcCrontabService for more details
             */
            $scope.executionTimeFrame = grcCrontabService.parseCrontab($scope.boxModel.CronTimeframe);

            $scope.executionTimeFrame.startTime = getFormattedTime($scope.executionTimeFrame.startTime);
            $scope.executionTimeFrame.endTime = getFormattedTime($scope.executionTimeFrame.endTime);
        }

        /**
         * Pads to match '00:00' format
         *
         * @param time {null|string}
         * @returns {null|string}
         */
        function getFormattedTime(time) {
            if (time === null) return null;

            return _.padStart(time, 5, '0');
        }

        function initSuggestedImpactLevel() {
            biaResponsibilityService
                .getBIAResponsibilityComputedImpactLevel(
                    $scope.boxContext.BIAProfile.BIAProfileID,
                    $scope.boxModel)
                .then(function (impact) {
                    if (impact && impact.ComputedImpactLevel) {
                        $scope.ctrlCtxt.suggestedImpactLevel = impact.ComputedImpactLevel;
                        var dims = 0;
                        if ($scope.boxModel.HasFinancialImpact) dims++;
                        if ($scope.boxModel.HasOperationalImpact) dims++;
                        if ($scope.boxModel.HasComplianceImpact) dims++;
                        $scope.ctrlCtxt.suggestedDimensionCount = dims;
                    }
                });
        }

        function initLocationLookup() {
            // BCMLocation is on ItemType 'PSPEmployee' (ID 16)
            adminReferenceDataService
                .getLookupAttributeValues('PSPEmployee')
                .then(function (lookupAttributes) {
                    if (lookupAttributes.BCMLocation) {
                        var locationsByID = _.keyBy(lookupAttributes.BCMLocation.LookupAttributeValues, 'LookupAttributeValueID');

                        if ($scope.boxModel.PrimaryLocationID) {
                            $scope.boxModel.PrimaryLocation = locationsByID[$scope.boxModel.PrimaryLocationID];
                        }
                        if ($scope.boxModel.FallbackLocationID) {
                            $scope.boxModel.FallbackLocation = locationsByID[$scope.boxModel.FallbackLocationID];
                        }
                    }
                });
        }
    }
})();